export default "__VITE_ASSET__Dlmjm$ou__"